import * as React from 'react';

import { cva, type VariantProps } from 'class-variance-authority';
import { Layouts, Responsive, WidthProvider } from 'react-grid-layout';

import { cn } from '../../../../lib/stylingUtils';

import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const layoutGridStyles = cva('', {
  variants: {
    size: {
      small: 'min-h-[12.5em]',
      medium: 'min-h-[25em]',
      large: 'min-h-[37.5em]',
    },
  },
  defaultVariants: {
    size: 'medium',
  },
});

export type LayoutGridProps = VariantProps<typeof layoutGridStyles> &
  React.PropsWithChildren & {
    layouts?: Layouts;
    className?: string;
  };

const ResponsiveGridLayout = WidthProvider(Responsive);

export const LayoutGrid = ({
  layouts,
  className,
  size,
  children,
}: LayoutGridProps) => (
  <ResponsiveGridLayout
    className={cn('@LayoutGrid', layoutGridStyles({ size, className }))}
    breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
    cols={{ lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 }}
    layouts={layouts}
    autoSize={false}
    isResizable={true}
    isDraggable={true}
    rowHeight={50}
    width={1000}
  >
    {children}
  </ResponsiveGridLayout>
);

const GridItem = ({
  style,
  className,
  onMouseDown,
  onMouseUp,
  onTouchEnd,
  ref,
  children,
}: React.HTMLAttributes<HTMLDivElement> &
  React.PropsWithChildren & { ref?: React.Ref<HTMLDivElement> }) => (
  <div
    ref={ref}
    style={{ ...style }}
    className={cn('@GridItem', className)}
    onMouseDown={onMouseDown}
    onMouseUp={onMouseUp}
    onTouchEnd={onTouchEnd}
  >
    {children}
  </div>
);
LayoutGrid.Item = GridItem;
